import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import upload from '../../../helpers/upload';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'PROPERTY_CONTENT',
  entryPoint: '/property-contents',
  collectionName: 'property_contents',
  querySearchListing: [
    ['name', ['content', ['id'] ]],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Property content created',
  successMessageUpdate: 'Property content updated',
  successMessageDelete: 'Property content deleted',
});

export default {
  ...triggers,
  savePicture(dispatch, getState, { typePicture = 'horizontal', contentId, picture }) {
    const data = {...picture};
    const url = config.APP_URL + `/property-contents/${contentId}/upload-picture/${typePicture}`;
    const file = data.image_file || {};
    if (data._new) delete data._new;
    data.original = data.original || {
      $type: 'file',
      value: {
        name: file.name,
        content_type: file.type,
        size: file.size,
        mtime: (new Date(file.lastModified || 0)).toISOString(),
      }
    };
    data.thumbnail = data.thumbnail || { $type: 'file', value: {} };
    data.hi_res = data.hi_res || { $type: 'file', value: {} };
    dispatch({ type: 'PROPERTY_CONTENT__UPLOAD_PICTURE' });
    return upload(url, data)
      .then(savedPicture => {
        dispatch({ type: 'PROPERTY_CONTENT__UPLOAD_PICTURE_SUCCESS', payload: savedPicture });
      })
      .catch(err => {
        dispatch({ type: 'PROPERTY_CONTENT__ERROR', payload: err });
      });
  },
  deletePicture(dispatch, getState, { typePicture, contentId, pictureId }) {
    const url = config.APP_URL + `/property-contents/${contentId}/delete-picture/${typePicture}`;
    dispatch({ type: 'PROPERTY_CONTENT__DELETE_PICTURE' });
    return httpRequest('DELETE', url)
      .then(() => {
        dispatch({ type: 'PROPERTY_CONTENT__DELETE_PICTURE_SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'PROPERTY_CONTENT__ERROR', payload: err });
      });
  },
  savePdf(dispatch, getState, { contentId, pdf, locale }) {
    const { payload, ...data } = pdf;
    const params = data.value ? data : {
      $type: 'file',
      value: {
        name: data.filename || payload.name,
        content_type: payload.type,
        size: payload.size,
        mtime: (new Date(payload.lastModified || 0)).toISOString(),
      }
    };
    const url = config.APP_URL + `/property-contents/${contentId}/upload-pdf`;
    dispatch({ type: 'PROPERTY_CONTENT__UPLOAD_PDF' });
    return upload(url, { ...params, file: payload, locale})
      .then(savedPdf => {
        dispatch({ type: 'PROPERTY_CONTENT__UPLOAD_PDF_SUCCESS', payload: savedPdf });
      })
      .catch(err => {
        dispatch({ type: 'PROPERTY_CONTENT__ERROR', payload: err });
      });
  },
  deletePdf(dispatch, getState, { contentId, locale }) {
    const url = config.APP_URL + `/property-contents/${contentId}/delete-pdf?locale=${locale}`;
    dispatch({ type: 'PROPERTY_CONTENT__DELETE_PDF' });
    return httpRequest('DELETE', url)
      .then(() => {
        dispatch({ type: 'PROPERTY_CONTENT__DELETE_PDF_SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'PROPERTY_CONTENT__ERROR', payload: err });
      });
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/triggers.js